import * as React from "react";
import {
  ReferenceInput,
  SelectInput,
  TextInput,
  NumberInput,
  required,
} from "react-admin";
import Transformer from "../../../common/Transformer";
import { CountryEnum, StateEnum } from "../../../common/enum";
import { TaxRatesTitle } from "./TaxRatesTitle";
import { insertIntoArray } from "src/common/UtilFunctions";
import { Edit, SimpleForm } from "src/enterprise/ra-rbac";
import { Grid } from "@mui/material";

export const TaxRatesEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt"],
      update: {
        tax: data.tax.id,
      },
    });

    return data;
  };

  const TaxRatesStateEnum = insertIntoArray(StateEnum, 1, {
    id: "*",
    name: "All",
  });

  return (
    <Edit
      title={<TaxRatesTitle />}
      mutationMode="pessimistic"
      transform={transform}
    >
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} lg={8}>
            <TextInput disabled source="id" />
          </Grid>
          <Grid item sm={12} lg={8}>
            <ReferenceInput source="tax.id" reference="admin/taxes">
              <SelectInput optionText="name" label="Tax" validate={required()} />
            </ReferenceInput>
          </Grid>
          <Grid item sm={12} lg={8}>
            <NumberInput source="rate" min={0} validate={required()} />
          </Grid>
          <Grid item sm={12} lg={8}>
            <TextInput source="zip" validate={required()} />
          </Grid>
          <Grid item sm={12} lg={8}>
            <SelectInput source="country" choices={CountryEnum} validate={required()} />
          </Grid>
          <Grid item sm={12} lg={8}>
            <SelectInput
              source="state"
              choices={TaxRatesStateEnum.slice(1)}
              emptyValue={""}
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
